define('uikit/elements/header',['require','exports','module','underscore','marionette','../mixins/component.mixin','../channel','../templates','../extra/size'],function(require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var ComponentMixin = require('../mixins/component.mixin');
  var channel = require('../channel');
  var Templates = require('../templates');
  var Size = require('../extra/size');

  var Header = Mn.ItemView.extend(ComponentMixin).extend({
    tagName: function() {
      if (this.getBoolOption('useHeaderElement') && this.getBoolOption('headerElementLevel')) {
        var intLevel = parseInt(this.getOption('headerElementLevel'));

        //Test to see if the header level is between 1 and 6 (the only legal values).
        if (1 <= intLevel === intLevel <= 6) {
          return 'h' + String(intLevel);
        } else {
          throw new Error(intLevel + ' is an invalid HTML header level.');
        }
      } else {
        return 'div';
      }
    },

    className: 'ui header',

    template: Templates.UIKit['header'],

    attributes: {
      role: 'heading',
    },

    options: {
      text: '',
      subText: '',
      icon: '',
      // this is an icon focused header
      // which means the icon will be big
      iconHeader: false,
      // this header is a sub header
      subHeader: false,
      dividing: false,
      block: false,
      formatter: null,
      attached: false,
      floated: false,
      aligned: false,
      inverted: false,
      color: false,
      muted: false,
      size: '',
      ariaLevel: '',
      //specify whether a semantic HTML header element should be used. The header level is configurable
      //and should be between 1 and 6.
      useHeaderElement: false,
      headerElementLevel: '',
    },

    sizeOptionValues: _.values(Size),

    forceUpdate: { text: true, subText: true, icon: true },

    serializeData: function() {
      var data = ComponentMixin.serializeData.apply(this, arguments);

      if (_.isFunction(this.formatter)) {
        data.text = this.formatter(this.text);
      }

      return data;
    },

    updateAttributes: function() {
      var attached = this.getOption('attached'),
        floated = this.getOption('floated'),
        aligned = this.getOption('aligned');

      if (this.getBoolOption('ariaLevel')) {
        this.updateElementAttributes({ 'aria-level': this.getOption('ariaLevel') });
      }

      this.addClass('icon', this.getBoolOption('iconHeader'))
        .addClass('dividing', this.getBoolOption('dividing'))
        .addClass('block', this.getBoolOption('block'))
        .addClass('sub', this.getBoolOption('subHeader'))
        .addClass((_.isString(attached) ? attached + ' ' : '') + 'attached', this.getBoolOption('attached'))
        .addClass(floated + ' floated', this.getBoolOption('floated'))
        .addClass(aligned + ' aligned', this.getBoolOption('aligned'))
        .addClass('inverted', this.getBoolOption('inverted'))
        .addClass(this.getOption('color'), this.getBoolOption('color'))
        .addClass(this.getOption('size'), this.getBoolOption('size'))
        .addClass('muted', this.getBoolOption('muted'));
    },
  });

  // register the header component
  channel.reply('header', function() {
    return Header;
  });

  module.exports = Header;
});

